
import * as styles from './styles.module.scss';

export type Variant =
	| 'chat-blue'
	| 'chat-green'
	| 'gr-bluegreen'
	| 'light'
	| 'lighter'
	| 'ol-blue'
	| 'ol-gray'
	| 'ol-green'
	| 'ol-red'
	| 'outline'
	| 'primary'
	| 'text'
	| 'underline'
;

export const vClass = (variant: Variant): string => {
	switch (variant) {
	case 'chat-blue':
		return styles.chatBlue;
	case 'chat-green':
		return styles.chatGreen;
	case 'gr-bluegreen':
		return styles.grBlueGreen;
	case 'light':
		return styles.light;
	case 'lighter':
		return styles.lighter;
	case 'ol-blue':
		return styles.olBlue;
	case 'ol-gray':
		return styles.olGray;
	case 'ol-green':
		return styles.olGreen;
	case 'ol-red':
		return styles.olRed;
	case 'outline':
		return styles.outline;
	case 'primary':
		return styles.primary;
	case 'text':
		return styles.text;
	case 'underline':
		return styles.underline;
	}
};

export type Height =
	| 'short'
	| 'medium'
	| 'tall'
;

export const hClass = (height?: Height): string => {
	switch (height) {
	case 'short':
		return styles.short;
	case 'medium':
		return styles.medium;
	case 'tall':
		return styles.tall;
	default:
		return '';
	}
};
